import { render, staticRenderFns } from "./RouteIcon.vue?vue&type=template&id=56cf30dc&"
import script from "./RouteIcon.vue?vue&type=script&lang=js&"
export * from "./RouteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports